import React, { useEffect } from 'react';
import { Paper, Typography, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router-dom';

import Storage from 'utils/storage';
import backgroundImage from 'assets/images/block_bg.png';
import chartImage from 'assets/images/Timings-chart.png';
import decksImage from 'assets/images/3_decks.png';
import badgeImage from 'assets/images/badge_final_aim.png';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
  },
  paper: {
    padding: '48px 60px',
    marginBottom: '50px',
    background: '#eee',
    textAlign: 'center',
    borderRadius: '6px',
  },
  title: {
    color: '#066',
    fontSize: '30px',
    fontWeight: '500',
    '&.main': {
      fontSize: '63px',
    },
  },
  contentPaper: {
    position: 'relative',
    padding: '20px',
    borderRadius: '16px',
    backgroundImage: `url(${backgroundImage})`,
  },
  description: {
    display: 'flex',
    marginBottom: '14px',
    padding: '12px',
    fontSize: '15px',
    color: '#fff',
    textAlign: 'left',
  },
  image: {
    marginRight: '10px',
    marginBottom: '10px',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    width: 'fit-content',
    marginLeft: 'auto',
    alignItems: 'center',
  },
  actions: {
    marginTop: '20px',
    textAlign: 'center',
  },
  button: {
    width: 'fit-content',
    padding: '5px 16px',
    margin: '5px 10px 10px',
    fontSize: '18px',
    backgroundColor: '#5b8d8b',
    borderColor: '#5b8d8b',
    borderRadius: '50px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#48706f',
    },
    '&.signup': {
      backgroundColor: '#794b6b',
      borderColor: '#794b6b',
      '&:hover': {
        backgroundColor: '#66445c',
      },
    },
    '&.topButton': {
      fontSize: '14px',
      padding: '3px 15px',
    },
  },
}));
const Home = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  useEffect(() => {
    Storage.auth.getAuthToken().then((token) => {
      if (token) {
        return navigate('/admin');
      }
    });
  }, [navigate]);

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <span>Have an account?</span>
        <Button
          variant='contained'
          disableElevation
          className={`${classes.button} topButton`}
          href='/login'
        >
          Log In
        </Button>
      </div>
      <Paper elevation={0} className={classes.paper}>
        <Typography className={classes.title}>
          Take flash cards to the next level
        </Typography>
        <Typography className={`${classes.title} main`}>
          <span style={{ color: '#000' }}>Fluency</span>
          {' FlashCards'}
        </Typography>
        <Paper
          elevation={0}
          className={classes.contentPaper}
          style={{
            backgroundImage: 'require(./block_bg.png)',
          }}
        >
          <div className={classes.description}>
            <Typography>
              Building upon an innovative, evidence-based learning method
              (SAFMEDS), perfected through decades of real-world use in diverse
              educational settings, <strong>Fluency FlashCards</strong> is a web
              2.0 application that enables your students to practice learning
              information to <strong>fluency</strong>, beyond
              accuracy--guaranteeing retention, endurance and application of
              their performance.
            </Typography>
          </div>
          <div className={classes.description}>
            <img
              className={classes.image}
              src={chartImage}
              style={{ width: '100px' }}
              alt='chart'
            />
            <Typography>
              <strong>Detailed Analytics:</strong> Using Standard Celeration
              Charts, learners get clear and informative data on their progress
              toward meeting a fluency aim for each deck. Fluency aims can be
              set based upon card content.
            </Typography>
          </div>
          <div className={classes.description}>
            <img
              className={classes.image}
              src={decksImage}
              style={{ width: '150px' }}
              alt='decks'
            />
            <Typography>
              Learners can build flash card decks of up to 84 cards, and
              practice in deck subsets that are cumulatively reviewed until the
              learner reaches a fluency aim. Fluency is based upon the learner's
              rate of performance in one-minute timings. After each timing
              performance data are plotted on a Timings Celeration Chart that
              automatically appears. The best of the day's timings are plotted
              on a Daily Celeration Chart that also automatically appears after
              the day's practice session. Shuffled cards pass through a series
              of decks on the way to meeting the fluency aim. A unique feature
              tracks latency data for each card. Cards whose performance
              latencies are below the average latency required for a deck
              continue to appear in timings, giving a learner an opportunity to
              practice beyond accuracy to fluency. In an accompanying video
              tutorial, Dr. Kent Johnson details how to write effective
              flashcards illustrating different kinds of learning, such as
              definitions, descriptions, equivalences, concepts and principles;
              and how to conduct effective practice timings to promote fluency
              and rapid growth in learning.
            </Typography>
          </div>
          <div className={classes.description}>
            <img
              className={classes.image}
              src={badgeImage}
              style={{ width: '80px' }}
              alt='chart'
            />
            <Typography>
              <strong>Reinforcement:</strong> Badges and other cheerleading
              events pop up throughout the process, encouraging the learner to
              continue.
            </Typography>
          </div>
        </Paper>
        <div className={classes.actions}>
          <Button
            variant='contained'
            disableElevation
            className={`${classes.button} signup`}
            href='https://elearningstoreinc.com/'
          >
            Sign Up
          </Button>
          <Button
            variant='contained'
            disableElevation
            className={classes.button}
            href='/login'
          >
            Log In
          </Button>
        </div>
      </Paper>
    </div>
  );
};

export default Home;
